import { createContext, useContext } from "react";
import { useSqeLabs } from "../../../../hooks/use-sqe-labs.ts";

export const SqeOnboardingLinkContext = createContext(false);

export function useSqeOnboardingApi(): boolean {
  const isSqeLink = useContext(SqeOnboardingLinkContext);
  const isSqePortal = useSqeLabs();
  return isSqeLink || isSqePortal;
}
